import { Typography } from "components";

const SuccessText: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Typography
    size={-1}
    color="#2e7d32"
    style={{
      background: "#e8f5e9",
      border: "solid 1px #c8e6c9",
      padding: "12px 14px",
      borderRadius: "8px",
    }}
  >
    {children}
  </Typography>
);

export { SuccessText };
